import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const styles = (theme: Theme) => {

	return createStyles({
		disqualifiersTextBox_disqualifiersTextBody: {

		},
		disqualifiersTextBox_preambleTextBody: {

		},
		disqualifiersTextBox_preambleText: {
			color: theme.palette.info.main,
			fontSize: theme.typography.h6.fontSize,
		},
		disqualifiersTextBox_conditionTextBody: {
			paddingLeft: theme.spacing(2.5),
		},
		disqualifiersTextBox_conditionText: {
			lineHeight: theme.spacing(3),
			color: theme.palette.info.main,
		},
		disqualifiersTextBox_postTextBody: {

		},
		disqualifiersTextBox_postText: {
			color: theme.palette.info.main,
			marginBottom: theme.spacing(1),
		},
	});
}

export default styles;
